<template>
	<v-list-item
		style="border: 1px solid #e0e0e0; border-radius: 5px"
	>
		<v-list-item-icon class="mr-3">
			<v-icon>mdi-file-document-outline</v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title style="overflow: hidden; width: 300px">
        <template v-if="isData">
          <span v-translate class="font-weight-bold">Data Consent</span>
        </template>
        <template v-else>
          <span v-translate class="font-weight-bold">Terapeutic Consent</span> - {{consent.title}}
        </template>
			</v-list-item-title>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters align="center">
				<v-btn icon @click="downloadConsent">
					<v-icon color="primary">mdi-download</v-icon>
				</v-btn>
				<v-btn icon @click="showDeleteConsent = true">
					<v-icon color="primary">delete</v-icon>
				</v-btn>
			</v-row>
		</v-list-item-action>
		<DeleteConfirmationDialog
			v-model="showDeleteConsent"
			item="consent"
			@delete="deleteConsent"
		/>
	</v-list-item>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
  name: "ConsentItem",
  props: ["consent", "isData"],
  components: {
    DeleteConfirmationDialog
  },
  data: () => ({
    showDeleteConsent: false
  }),
  methods: {
    downloadConsent() {
      var blob;
      if(this.isData) blob = this.consent;
      else blob = this.consent.blob;
			var link = document.createElement("a");
			link.href = 
				"https://api.naltio.com/download/"
				//"http://127.0.0.1:5500/download/"
				+ blob
			link.target = "_self";
			document.body.appendChild(link);
			link.click();
    },
    deleteConsent() {
      if(this.isData) this.deleteDataConsent();
      else this.deleteTerapeuticConsent();
    },
		deleteDataConsent() {
			let patientId = this.$route.params.pid;
			axios
				.post("/patient/" + patientId + "/data-consent/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == 'deleted') {
            this.$emit('delete');
            this.showDeleteConsent = false;
          }
				})
				.catch(error => {
          console.log(error);
				});
		},
		deleteTerapeuticConsent() {
			let patientId = this.$route.params.pid;
			axios
				.post("/patient/" + patientId + "/terapeutic-consent/" + this.consent.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == 'deleted') {
            this.$emit('delete', this.consent);
            this.showDeleteConsent = false;
          }
				})
				.catch(error => {
          console.log(error);
				});
		}
  }
}
</script>